"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAccess = void 0;
var utils_1 = require("./utils");
// AccessCodes为权限枚举类型，需由外部传入
var useAccess = function (code, accessOperator) {
    if (accessOperator === void 0) { accessOperator = 'or'; }
    var codeMap = utils_1.getJSON(utils_1.StorageKeys.permission) || {};
    var hasAuth;
    if (typeof code === 'string') {
        hasAuth = codeMap[code];
    }
    else if (Array.isArray(code)) {
        switch (accessOperator) {
            case 'and':
                hasAuth = code.every(function (subCode) { return codeMap[subCode]; });
                break;
            case 'or':
            default:
                hasAuth = code.some(function (subCode) { return codeMap[subCode]; });
                break;
        }
    }
    return !!hasAuth;
};
exports.useAccess = useAccess;
